import { render, staticRenderFns } from "./ProductSwatchesSimple.vue?vue&type=template&id=77ef75dc&scoped=true&lang=pug&"
import script from "./ProductSwatchesSimple.vue?vue&type=script&lang=js&"
export * from "./ProductSwatchesSimple.vue?vue&type=script&lang=js&"
import style0 from "./ProductSwatchesSimple.vue?vue&type=style&index=0&id=77ef75dc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77ef75dc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jackie/sites/cardinalco/ylang-23/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77ef75dc')) {
      api.createRecord('77ef75dc', component.options)
    } else {
      api.reload('77ef75dc', component.options)
    }
    module.hot.accept("./ProductSwatchesSimple.vue?vue&type=template&id=77ef75dc&scoped=true&lang=pug&", function () {
      api.rerender('77ef75dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/product/ProductSwatchesSimple.vue"
export default component.exports